export const languages = [
    { code: "hr", label: "🇭🇷", country: "HR", name: "Croatian" },
    { code: "en", label: "🇬🇧", country: "GB", name: "English" },
    { code: "de", label: "🇩🇪", country: "DE", name: "German" },
    { code: "fr", label: "🇫🇷", country: "FR", name: "French" },
    { code: "es", label: "🇪🇸", country: "ES", name: "Spanish" },
];

export const languageEnum = {
    hr: 1,
    en: 2,
    de: 3,
    fr: 4,
    es: 5,
};
